// Mock Bid Intelligence Data
// Based on 4 Core Models: Project, Component, Client, Market Context

export const BILL_RATES = {
  'Sr AM': 175,
  'Acct Mgr': 150,
  'Asst Acct Mgr': 75,
  'Marketing Support': 50,
  'Principal': 275,
  'Freelance': 75
};

export const STAFF_ROLES = Object.keys(BILL_RATES);

// Component Types (Standardized Services)
export const RETAINER_TYPES = [
  { id: 'retainer-a', name: 'Retainer A - Full-Service PR', category: 'retainer' },
  { id: 'retainer-b', name: 'Retainer B - Media Relations Focus', category: 'retainer' },
  { id: 'retainer-c', name: 'Retainer C - Digital/Social Focus', category: 'retainer' }
];

export const PROJECT_TYPES = [
  { id: 'advertising',         name: 'Advertising' },
  { id: 'awards-campaign',     name: 'Awards Campaign' },
  { id: 'crisis-response',     name: 'Crisis Response' },
  { id: 'marketing-materials', name: 'Marketing Materials' },
  { id: 'media-relations',     name: 'Media Relations' },
  { id: 'newsletter-program',  name: 'Newsletter Program' },
  { id: 'nominations',         name: 'Nominations' },
  { id: 'press-event',         name: 'Press Conference / Event' },
  { id: 'rebranding',          name: 'Rebranding / Positioning' },
  { id: 'seo',                 name: 'SEO Implementation' },
  { id: 'social-media',        name: 'Social Media' },
  { id: 'speaking',            name: 'Speaking' },
  { id: 'strategic-marketing', name: 'Strategic Marketing' },
  { id: 'thought-leadership',  name: 'Thought Leadership' },
  { id: 'webinars',            name: 'Webinars' },
  { id: 'website-development', name: 'Website Development' },
  { id: 'others',              name: 'Other' },
];


// Client Names from User's System
export const CLIENT_NAMES = [
  'McNicholas & McNicholas, LLP',
  'Sheppard Mullin',
  'Pearlman, Brown & Wax, LLP',
  'Omnus Law Services, LLC',
  'Donohoe Talbert LLP',
  'Taylor & Ring',
  'Soroka & Associates LLC',
  'Falcon Wealth Planning',
  'Sacks, Glazier, Franklin, Lodise, McMurtrey & Scheerer, LLP',
  'Gray, Duffy, Eisenbaum & Lee, LLP',
  'Liebert Cassidy Whitmore',
  'Merlin Law Group',
  'BD&J',
  'GCP Advisors',
  'Stradley Ronon',
  'Equity Ag Financial, Inc.',
  'The Zinn Law Firm',
  'Thompson Coburn',
  'Assalone Lombardi',
  'Steven Weisburd'
];

// Industry classifications
export const INDUSTRIES = {
  'Law': ['McNicholas & McNicholas, LLP', 'Sheppard Mullin', 'Pearlman, Brown & Wax, LLP', 
          'Omnus Law Services, LLC', 'Donohoe Talbert LLP', 'Taylor & Ring', 
          'Soroka & Associates LLC', 'Sacks, Glazier, Franklin, Lodise, McMurtrey & Scheerer, LLP',
          'Gray, Duffy, Eisenbaum & Lee, LLP', 'Liebert Cassidy Whitmore', 'Merlin Law Group',
          'Stradley Ronon', 'The Zinn Law Firm', 'Thompson Coburn', 'Assalone Lombardi'],
  'Financial Services': ['Falcon Wealth Planning', 'BD&J', 'GCP Advisors', 'Equity Ag Financial, Inc.'],
  'Professional Services': ['Steven Weisburd']
};

export const CLIENT_SIZES = ['Small', 'Medium', 'Large'];
export const COMPLEXITY_LEVELS = ['Low', 'Medium', 'High'];

// Historical Projects (Past Engagements with Intelligence)
export const HISTORICAL_PROJECTS = [
  {
    id: 'proj_001',
    clientName: 'McNicholas & McNicholas, LLP',
    industry: 'Law',
    clientSize: 'Large',
    complexity: 'High',
    componentType: 'retainer-a',
    componentName: 'Retainer A - Full-Service PR',
    startDate: '2023-06-01',
    endDate: '2024-06-01',
    status: 'Won',
    
    // Bid metrics
    bidAmount: 72000, // Annual
    bidMonthly: 6000,
    estimatedHours: 600, // Annual
    estimatedMonthly: 50,
    
    // Actual delivery
    actualHours: 660, // 10% over
    actualMonthly: 55,
    actualCost: 82500,
    
    // Intelligence
    variance: 10.0, // % over estimate
    marginEstimated: 42,
    marginActual: 35,
    marginDelta: -7,
    overUnderService: 'Over', // Overserviced
    profitability: 35,
    
    services: [
      { name: 'Media Relations', hours: 300, role: 'Sr AM' },
      { name: 'Social Media', hours: 180, role: 'Asst Acct Mgr' },
      { name: 'Awards & Recognition', hours: 120, role: 'Acct Mgr' }
    ]
  },
  
  {
    id: 'proj_002',
    clientName: 'Sheppard Mullin',
    industry: 'Law',
    clientSize: 'Large',
    complexity: 'Medium',
    componentType: 'press-event',
    componentName: 'Press Conference/Event',
    startDate: '2023-09-15',
    endDate: '2023-11-30',
    status: 'Won',
    
    bidAmount: 25000,
    bidMonthly: null,
    estimatedHours: 150,
    estimatedMonthly: null,
    
    actualHours: 145,
    actualMonthly: null,
    actualCost: 19500,
    
    variance: -3.3, // Under estimate (efficient!)
    marginEstimated: 38,
    marginActual: 45,
    marginDelta: 7,
    overUnderService: 'On Target',
    profitability: 45,
    
    services: [
      { name: 'Event Planning', hours: 80, role: 'Acct Mgr' },
      { name: 'Media Outreach', hours: 45, role: 'Sr AM' },
      { name: 'Logistics', hours: 20, role: 'Asst Acct Mgr' }
    ]
  },

  {
    id: 'proj_003',
    clientName: 'Falcon Wealth Planning',
    industry: 'Financial Services',
    clientSize: 'Medium',
    complexity: 'Medium',
    componentType: 'retainer-c',
    componentName: 'Retainer C - Digital/Social Focus',
    startDate: '2023-03-01',
    endDate: '2024-03-01',
    status: 'Won',
    
    bidAmount: 48000,
    bidMonthly: 4000,
    estimatedHours: 480,
    estimatedMonthly: 40,
    
    actualHours: 480,
    actualMonthly: 40,
    actualCost: 52000,
    
    variance: 0, // Perfect estimate!
    marginEstimated: 38,
    marginActual: 38,
    marginDelta: 0,
    overUnderService: 'On Target',
    profitability: 38,
    
    services: [
      { name: 'Social Media Management', hours: 360, role: 'Asst Acct Mgr' },
      { name: 'Content Strategy', hours: 80, role: 'Acct Mgr' },
      { name: 'Analytics', hours: 40, role: 'Marketing Support' }
    ]
  },

  {
    id: 'proj_004',
    clientName: 'Taylor & Ring',
    industry: 'Law',
    clientSize: 'Medium',
    complexity: 'High',
    componentType: 'awards',
    componentName: 'Awards Campaign',
    startDate: '2024-01-01',
    endDate: '2024-04-30',
    status: 'Won',
    
    bidAmount: 18000,
    bidMonthly: null,
    estimatedHours: 120,
    estimatedMonthly: null,
    
    actualHours: 155,
    actualMonthly: null,
    actualCost: 21000,
    
    variance: 29.2, // Significantly over
    marginEstimated: 42,
    marginActual: 28,
    marginDelta: -14,
    overUnderService: 'Over',
    profitability: 28,
    
    services: [
      { name: 'Application Writing', hours: 90, role: 'Acct Mgr' },
      { name: 'Research', hours: 45, role: 'Asst Acct Mgr' },
      { name: 'Coordination', hours: 20, role: 'Marketing Support' }
    ]
  },

  {
    id: 'proj_005',
    clientName: 'Merlin Law Group',
    industry: 'Law',
    clientSize: 'Small',
    complexity: 'Low',
    componentType: 'retainer-b',
    componentName: 'Retainer B - Media Relations Focus',
    startDate: '2023-08-01',
    endDate: '2024-08-01',
    status: 'Won',
    
    bidAmount: 36000,
    bidMonthly: 3000,
    estimatedHours: 360,
    estimatedMonthly: 30,
    
    actualHours: 350,
    actualMonthly: 29.2,
    actualCost: 45000,
    
    variance: -2.8, // Slightly under
    marginEstimated: 40,
    marginActual: 41,
    marginDelta: 1,
    overUnderService: 'On Target',
    profitability: 41,
    
    services: [
      { name: 'Media Relations', hours: 240, role: 'Sr AM' },
      { name: 'Press Release Writing', hours: 80, role: 'Acct Mgr' },
      { name: 'Media Monitoring', hours: 40, role: 'Asst Acct Mgr' }
    ]
  },

  {
    id: 'proj_006',
    clientName: 'GCP Advisors',
    industry: 'Financial Services',
    clientSize: 'Small',
    complexity: 'Medium',
    componentType: 'website',
    componentName: 'Website Development',
    startDate: '2023-10-01',
    endDate: '2024-01-31',
    status: 'Won',
    
    bidAmount: 35000,
    bidMonthly: null,
    estimatedHours: 200,
    estimatedMonthly: null,
    
    actualHours: 220,
    actualMonthly: null,
    actualCost: 28000,
    
    variance: 10.0,
    marginEstimated: 35,
    marginActual: 28,
    marginDelta: -7,
    overUnderService: 'Over',
    profitability: 28,
    
    services: [
      { name: 'Design & Development', hours: 120, role: 'Freelance' },
      { name: 'Content Creation', hours: 60, role: 'Acct Mgr' },
      { name: 'Project Management', hours: 40, role: 'Sr AM' }
    ]
  },

  {
    id: 'proj_007',
    clientName: 'Liebert Cassidy Whitmore',
    industry: 'Law',
    clientSize: 'Large',
    complexity: 'High',
    componentType: 'retainer-a',
    componentName: 'Retainer A - Full-Service PR',
    startDate: '2024-01-01',
    endDate: null,
    status: 'Won',
    
    bidAmount: 84000,
    bidMonthly: 7000,
    estimatedHours: 720,
    estimatedMonthly: 60,
    
    actualHours: 780,
    actualMonthly: 65,
    actualCost: 98000,
    
    variance: 8.3,
    marginEstimated: 40,
    marginActual: 33,
    marginDelta: -7,
    overUnderService: 'Over',
    profitability: 33,
    
    services: [
      { name: 'Media Relations', hours: 360, role: 'Sr AM' },
      { name: 'Social Media', hours: 240, role: 'Asst Acct Mgr' },
      { name: 'Thought Leadership', hours: 120, role: 'Acct Mgr' },
      { name: 'Strategic Oversight', hours: 60, role: 'Principal' }
    ]
  },

  {
    id: 'proj_008',
    clientName: 'BD&J',
    industry: 'Financial Services',
    clientSize: 'Medium',
    complexity: 'Low',
    componentType: 'seo',
    componentName: 'SEO Implementation',
    startDate: '2023-07-01',
    endDate: '2023-12-31',
    status: 'Won',
    
    bidAmount: 24000,
    bidMonthly: null,
    estimatedHours: 180,
    estimatedMonthly: null,
    
    actualHours: 175,
    actualMonthly: null,
    actualCost: 19500,
    
    variance: -2.8,
    marginEstimated: 38,
    marginActual: 40,
    marginDelta: 2,
    overUnderService: 'On Target',
    profitability: 40,
    
    services: [
      { name: 'SEO Strategy', hours: 60, role: 'Acct Mgr' },
      { name: 'Implementation', hours: 90, role: 'Asst Acct Mgr' },
      { name: 'Reporting', hours: 25, role: 'Marketing Support' }
    ]
  },

  {
    id: 'proj_009',
    clientName: 'Stradley Ronon',
    industry: 'Law',
    clientSize: 'Large',
    complexity: 'Medium',
    componentType: 'crisis',
    componentName: 'Crisis Response',
    startDate: '2024-03-15',
    endDate: '2024-04-30',
    status: 'Lost', // Lost bid
    
    bidAmount: 45000,
    bidMonthly: null,
    estimatedHours: 250,
    estimatedMonthly: null,
    
    actualHours: null,
    actualMonthly: null,
    actualCost: null,
    
    variance: null,
    marginEstimated: 45,
    marginActual: null,
    marginDelta: null,
    overUnderService: null,
    profitability: null,
    
    services: [] // Not won, no actual data
  },

  {
    id: 'proj_010',
    clientName: 'Donohoe Talbert LLP',
    industry: 'Law',
    clientSize: 'Medium',
    complexity: 'Medium',
    componentType: 'retainer-b',
    componentName: 'Retainer B - Media Relations Focus',
    startDate: '2023-11-01',
    endDate: '2024-11-01',
    status: 'Won',
    
    bidAmount: 42000,
    bidMonthly: 3500,
    estimatedHours: 420,
    estimatedMonthly: 35,
    
    actualHours: 465,
    actualMonthly: 38.75,
    actualCost: 55000,
    
    variance: 10.7,
    marginEstimated: 38,
    marginActual: 30,
    marginDelta: -8,
    overUnderService: 'Over',
    profitability: 30,
    
    services: [
      { name: 'Media Relations', hours: 280, role: 'Sr AM' },
      { name: 'Content Creation', hours: 120, role: 'Acct Mgr' },
      { name: 'Media Monitoring', hours: 65, role: 'Asst Acct Mgr' }
    ]
  },

  {
    id: 'proj_011',
    clientName: 'Thompson Coburn',
    industry: 'Law',
    clientSize: 'Large',
    complexity: 'High',
    componentType: 'thought-leadership',
    componentName: 'Thought Leadership',
    startDate: '2024-02-01',
    endDate: '2024-07-31',
    status: 'Won',
    
    bidAmount: 32000,
    bidMonthly: null,
    estimatedHours: 180,
    estimatedMonthly: null,
    
    actualHours: 185,
    actualMonthly: null,
    actualCost: 26500,
    
    variance: 2.8,
    marginEstimated: 40,
    marginActual: 38,
    marginDelta: -2,
    overUnderService: 'On Target',
    profitability: 38,
    
    services: [
      { name: 'Content Strategy', hours: 80, role: 'Sr AM' },
      { name: 'Article Writing', hours: 80, role: 'Acct Mgr' },
      { name: 'Distribution', hours: 25, role: 'Asst Acct Mgr' }
    ]
  },

  {
    id: 'proj_012',
    clientName: 'Soroka & Associates LLC',
    industry: 'Law',
    clientSize: 'Small',
    complexity: 'Low',
    componentType: 'website',
    componentName: 'Website Development',
    startDate: '2023-05-01',
    endDate: '2023-08-31',
    status: 'Won',
    
    bidAmount: 22000,
    bidMonthly: null,
    estimatedHours: 140,
    estimatedMonthly: null,
    
    actualHours: 135,
    actualMonthly: null,
    actualCost: 16500,
    
    variance: -3.6,
    marginEstimated: 35,
    marginActual: 38,
    marginDelta: 3,
    overUnderService: 'On Target',
    profitability: 38,
    
    services: [
      { name: 'Design & Development', hours: 90, role: 'Freelance' },
      { name: 'Content Creation', hours: 35, role: 'Acct Mgr' },
      { name: 'SEO Setup', hours: 10, role: 'Marketing Support' }
    ]
  },

  {
    id: 'proj_013',
    clientName: 'Equity Ag Financial, Inc.',
    industry: 'Financial Services',
    clientSize: 'Medium',
    complexity: 'Medium',
    componentType: 'retainer-c',
    componentName: 'Retainer C - Digital/Social Focus',
    startDate: '2024-04-01',
    endDate: null,
    status: 'Won',
    
    bidAmount: 54000,
    bidMonthly: 4500,
    estimatedHours: 540,
    estimatedMonthly: 45,
    
    actualHours: 540,
    actualMonthly: 45,
    actualCost: 58500,
    
    variance: 0,
    marginEstimated: 38,
    marginActual: 38,
    marginDelta: 0,
    overUnderService: 'On Target',
    profitability: 38,
    
    services: [
      { name: 'Social Media Management', hours: 400, role: 'Asst Acct Mgr' },
      { name: 'Content Strategy', hours: 100, role: 'Acct Mgr' },
      { name: 'Reporting', hours: 40, role: 'Marketing Support' }
    ]
  },

  {
    id: 'proj_014',
    clientName: 'The Zinn Law Firm',
    industry: 'Law',
    clientSize: 'Small',
    complexity: 'High',
    componentType: 'rebranding',
    componentName: 'Rebranding/Positioning',
    startDate: '2023-09-01',
    endDate: '2024-02-29',
    status: 'Lost',
    
    bidAmount: 38000,
    bidMonthly: null,
    estimatedHours: 220,
    estimatedMonthly: null,
    
    actualHours: null,
    actualMonthly: null,
    actualCost: null,
    
    variance: null,
    marginEstimated: 42,
    marginActual: null,
    marginDelta: null,
    overUnderService: null,
    profitability: null,
    
    services: []
  },

  {
    id: 'proj_015',
    clientName: 'Pearlman, Brown & Wax, LLP',
    industry: 'Law',
    clientSize: 'Large',
    complexity: 'Medium',
    componentType: 'retainer-a',
    componentName: 'Retainer A - Full-Service PR',
    startDate: '2023-04-01',
    endDate: '2024-04-01',
    status: 'Won',
    
    bidAmount: 78000,
    bidMonthly: 6500,
    estimatedHours: 660,
    estimatedMonthly: 55,
    
    actualHours: 635,
    actualMonthly: 52.9,
    actualCost: 89000,
    
    variance: -3.8,
    marginEstimated: 41,
    marginActual: 44,
    marginDelta: 3,
    overUnderService: 'On Target',
    profitability: 44,
    
    services: [
      { name: 'Media Relations', hours: 320, role: 'Sr AM' },
      { name: 'Social Media', hours: 200, role: 'Asst Acct Mgr' },
      { name: 'Awards', hours: 80, role: 'Acct Mgr' },
      { name: 'Strategic Planning', hours: 35, role: 'Principal' }
    ]
  },

  {
    id: 'proj_016',
    clientName: 'Steven Weisburd',
    industry: 'Professional Services',
    clientSize: 'Small',
    complexity: 'Low',
    componentType: 'press-event',
    componentName: 'Press Conference/Event',
    startDate: '2024-05-01',
    endDate: '2024-06-15',
    status: 'Won',
    
    bidAmount: 15000,
    bidMonthly: null,
    estimatedHours: 90,
    estimatedMonthly: null,
    
    actualHours: 95,
    actualMonthly: null,
    actualCost: 12500,
    
    variance: 5.6,
    marginEstimated: 38,
    marginActual: 34,
    marginDelta: -4,
    overUnderService: 'On Target',
    profitability: 34,
    
    services: [
      { name: 'Event Planning', hours: 50, role: 'Acct Mgr' },
      { name: 'Media Outreach', hours: 30, role: 'Sr AM' },
      { name: 'Logistics', hours: 15, role: 'Asst Acct Mgr' }
    ]
  },

  {
    id: 'proj_017',
    clientName: 'Assalone Lombardi',
    industry: 'Law',
    clientSize: 'Small',
    complexity: 'Medium',
    componentType: 'awards',
    componentName: 'Awards Campaign',
    startDate: '2024-01-15',
    endDate: '2024-05-31',
    status: 'Won',
    
    bidAmount: 16000,
    bidMonthly: null,
    estimatedHours: 110,
    estimatedMonthly: null,
    
    actualHours: 125,
    actualMonthly: null,
    actualCost: 16000,
    
    variance: 13.6,
    marginEstimated: 40,
    marginActual: 32,
    marginDelta: -8,
    overUnderService: 'Over',
    profitability: 32,
    
    services: [
      { name: 'Application Writing', hours: 75, role: 'Acct Mgr' },
      { name: 'Research', hours: 35, role: 'Asst Acct Mgr' },
      { name: 'Coordination', hours: 15, role: 'Marketing Support' }
    ]
  },

  {
    id: 'proj_018',
    clientName: 'Gray, Duffy, Eisenbaum & Lee, LLP',
    industry: 'Law',
    clientSize: 'Large',
    complexity: 'Low',
    componentType: 'newsletter',
    componentName: 'Newsletter Program',
    startDate: '2023-06-01',
    endDate: '2024-06-01',
    status: 'Won',
    
    bidAmount: 30000,
    bidMonthly: 2500,
    estimatedHours: 300,
    estimatedMonthly: 25,
    
    actualHours: 295,
    actualMonthly: 24.6,
    actualCost: 32000,
    
    variance: -1.7,
    marginEstimated: 35,
    marginActual: 36,
    marginDelta: 1,
    overUnderService: 'On Target',
    profitability: 36,
    
    services: [
      { name: 'Content Strategy', hours: 120, role: 'Acct Mgr' },
      { name: 'Writing', hours: 140, role: 'Asst Acct Mgr' },
      { name: 'Design', hours: 35, role: 'Marketing Support' }
    ]
  }
];

// Market Context - Pricing Distributions by Segment
export const PRICING_CONTEXT = {
  retainers: {
    'Law-Large': {
      'retainer-a': { min: 5500, median: 6500, upper: 7500, max: 8500, sampleSize: 5 },
      'retainer-b': { min: 3000, median: 3500, upper: 4000, max: 4500, sampleSize: 3 },
      'retainer-c': { min: 3500, median: 4000, upper: 5000, max: 6000, sampleSize: 2 }
    },
    'Law-Medium': {
      'retainer-a': { min: 4000, median: 5000, upper: 6000, max: 7000, sampleSize: 3 },
      'retainer-b': { min: 2500, median: 3500, upper: 4000, max: 4500, sampleSize: 4 },
      'retainer-c': { min: 3000, median: 3500, upper: 4000, max: 5000, sampleSize: 2 }
    },
    'Law-Small': {
      'retainer-a': { min: 3000, median: 4000, upper: 5000, max: 6000, sampleSize: 2 },
      'retainer-b': { min: 2000, median: 3000, upper: 3500, max: 4000, sampleSize: 3 },
      'retainer-c': { min: 2500, median: 3000, upper: 3500, max: 4000, sampleSize: 1 }
    },
    'Financial Services-Medium': {
      'retainer-a': { min: 4000, median: 5000, upper: 6000, max: 7000, sampleSize: 2 },
      'retainer-b': { min: 2500, median: 3000, upper: 3500, max: 4000, sampleSize: 1 },
      'retainer-c': { min: 3500, median: 4000, upper: 4500, max: 5000, sampleSize: 3 }
    },
    'Financial Services-Small': {
      'retainer-a': { min: 3000, median: 4000, upper: 5000, max: 6000, sampleSize: 1 },
      'retainer-b': { min: 2000, median: 2500, upper: 3000, max: 3500, sampleSize: 1 },
      'retainer-c': { min: 2500, median: 3000, upper: 3500, max: 4000, sampleSize: 2 }
    }
  },
  projects: {
    'Law-Large': {
      'press-event': { min: 18000, median: 22000, upper: 25000, max: 30000, sampleSize: 3 },
      'website': { min: 28000, median: 32000, upper: 35000, max: 40000, sampleSize: 2 },
      'awards': { min: 15000, median: 18000, upper: 22000, max: 25000, sampleSize: 2 },
      'crisis': { min: 35000, median: 40000, upper: 45000, max: 50000, sampleSize: 1 }
    },
    'Law-Medium': {
      'press-event': { min: 12000, median: 15000, upper: 18000, max: 22000, sampleSize: 2 },
      'website': { min: 20000, median: 25000, upper: 30000, max: 35000, sampleSize: 2 },
      'awards': { min: 12000, median: 16000, upper: 18000, max: 22000, sampleSize: 3 }
    },
    'Law-Small': {
      'press-event': { min: 10000, median: 12000, upper: 15000, max: 18000, sampleSize: 2 },
      'website': { min: 18000, median: 22000, upper: 25000, max: 30000, sampleSize: 2 },
      'awards': { min: 10000, median: 14000, upper: 16000, max: 20000, sampleSize: 2 }
    },
    'Financial Services-Medium': {
      'website': { min: 22000, median: 28000, upper: 32000, max: 38000, sampleSize: 2 },
      'seo': { min: 18000, median: 22000, upper: 24000, max: 28000, sampleSize: 2 }
    },
    'Financial Services-Small': {
      'website': { min: 18000, median: 22000, upper: 28000, max: 32000, sampleSize: 2 },
      'seo': { min: 15000, median: 20000, upper: 24000, max: 28000, sampleSize: 1 }
    }
  }
};

// Client-specific intelligence (overservice patterns)
export const CLIENT_INTELLIGENCE = {
  'McNicholas & McNicholas, LLP': {
    totalProjects: 1,
    avgOverUnder: 10.0,
    flag: 'Tends to overservice',
    notes: 'High expectations, scope creep common'
  },
  'Taylor & Ring': {
    totalProjects: 1,
    avgOverUnder: 29.2,
    flag: 'Significant overservice risk',
    notes: 'Complex requirements, frequent changes'
  },
  'Falcon Wealth Planning': {
    totalProjects: 1,
    avgOverUnder: 0,
    flag: 'Reliable client',
    notes: 'Clear scope, on-target delivery'
  },
  'Merlin Law Group': {
    totalProjects: 1,
    avgOverUnder: -2.8,
    flag: 'Efficient client',
    notes: 'Well-organized, minimal scope changes'
  },
  'Donohoe Talbert LLP': {
    totalProjects: 1,
    avgOverUnder: 10.7,
    flag: 'Tends to overservice',
    notes: 'Additional requests common'
  }
};